import { render, staticRenderFns } from "./SucTextFormShowField.vue?vue&type=template&id=28dbe654&"
import script from "./SucTextFormShowField.vue?vue&type=script&lang=js&"
export * from "./SucTextFormShowField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28dbe654')) {
      api.createRecord('28dbe654', component.options)
    } else {
      api.reload('28dbe654', component.options)
    }
    module.hot.accept("./SucTextFormShowField.vue?vue&type=template&id=28dbe654&", function () {
      api.rerender('28dbe654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/SucTextFormShowField.vue"
export default component.exports